<!--====== HEADER PART START ======-->
<header class="header-area header-area-2 header-area-4">
    <div class="header-top pl-30 pr-30">
        <div class="row align-items-center">
            <div class="col-md-6 col-sm-7">
                <div class="header-left-side text-center text-sm-left">
                    <ul>
                        <li class="contact"><a href="#"><i class="fal fa-envelope"></i>contact&#64;inclusiveguarantee.fr</a></li>
                        <span class="barre"></span>
                        <li class="phone"><a href="#"><i class="fal fa-phone"></i> + 221 33 864 54 55</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 col-sm-5">
                <div class="header-right-social text-center text-sm-right">
                    <ul>
                        <li><a href="https://www.facebook.com/inclusiveguarantee1/" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                        <li><a href="https://twitter.com/inclusiveibm" target="_blank"><i class="fab fa-twitter"></i></a></li>
                        <!-- <li><a href="#"><i class="fab fa-behance"></i></a></li> -->
                        <li><a href="https://www.linkedin.com/company/inclusive-guarantee/" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                        <!-- <li><a href="#"><i class="fab fa-youtube"></i></a></li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="header-nav">
        <div class="navigation">
            <nav class="navbar navbar-expand-lg navbar-light ">
                <a class="navbar-brand" routerLink='/' (click)="getRoute('','accueil')"><img src="assets/images/logo.png" alt=""></a>
                <!-- logo -->
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="toggler-icon"></span>
                    <span class="toggler-icon"></span>
                    <span class="toggler-icon"></span>
                </button>
                <!-- navbar toggler -->
                <div class="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item " [class.active]="sectionShown == 'accueil'">
                            <a routerLink='/' (click)="getRoute('','accueil')">Accueil</a>
                        </li>
                        <li class="nav-item" [class.active]="sectionShown == 'auto-mono'">
                            <a class="nav-link" routerLink='/auto-mono' (click)="getRoute('','auto-mono')">Auto</a>
                        </li>
                        <li class="nav-item" [class.active]="sectionShown == 'multirisque'">
                            <a class="nav-link" (click)="getRoute('','')">Multirisque <i class="fal fa-chevron-down"></i></a>
                            <ul class="sub-menu">
                                <li><a routerLink='/multirisque-pro' (click)="getRoute('Multirisque pro','multirisque')">Multirisque pro</a></li>
                                <li><a routerLink='/multirisque-habitat' (click)="getRoute('Multirisque habitat','multirisque')">Mutlirisque habitat</a></li>
                            </ul>
                        </li>
                        <li class="nav-item" [class.active]="sectionShown == 'sante'">
                            <a class="nav-link" routerLink='/sante' (click)="getRoute('','sante')">Sante</a>
                        </li>
                        <li class="nav-item" [class.active]="sectionShown == 'vie'">
                            <a class="nav-link" (click)="getRoute('','')">Vie <i class="fal fa-chevron-down"></i> </a>
                            <ul class="sub-menu">
                                <li><a routerLink='/prevoyance-deces' (click)="getRoute('Prévoyance décès','vie')">Prévoyance décès</a></li>
                                <li><a routerLink='/prevoyance-retraite' (click)="getRoute('Retraite','vie')">Retraite</a></li>
                                <li><a routerLink='/prevoyance-education' (click)="getRoute('Education','vie')">Education</a></li>
                            </ul>
                        </li>
                        <li class="nav-item" [class.active]="sectionShown == 'voyage'">
                            <a class="nav-link" routerLink='/voyage' (click)="getRoute('','voyage')">Voyage</a>
                        </li>
                        <li class="nav-item" [class.active]="sectionShown == ''">
                            <a class="nav-link" (click)="getRoute('','')">Autres <i class="fal fa-chevron-down"></i> </a>
                            <ul class="sub-menu" *ngIf="safariClass!='isSafari'">
                                <li><a class="nav-link" routerLink='/accident-individuel' (click)="getRoute('','accident-individuel')">Individuelle accidents</a></li>
                                <li><a class="nav-link" routerLink='/stock-marchandises' (click)="getRoute('','stock-marchandises')">Stock marchandises</a></li>
                            </ul>
                            <ul class="sub-menu isSafari" *ngIf="safariClass=='isSafari'">
                                <li><a class="nav-link" routerLink='/accident-individuel' (click)="getRoute('','accident-individuel')">Individuelle accidents</a></li>
                                <li><a class="nav-link" routerLink='/stock-marchandises' (click)="getRoute('','stock-marchandises')">Stock marchandises</a></li>
                            </ul>
                        </li>
                        <!-- <li class="nav-item">
                            <a class="nav-link" routerLink='/contact-us' >Connexion</a>
                        </li> -->
                    </ul>
                </div>
                <!-- navbar collapse -->
                <!-- <div class="bar-area d-none d-xl-block">
                    <ul>
                        <li><a href="#"><i class="fal fa-shopping-cart"></i></a></li>
                        <li><a href="#"><i class="fal fa-search"></i></a></li>
                        <li><a href="#"><i class="fal fa-bars"></i></a></li>
                    </ul>
                </div> -->
                <div class="navbar-btn mr-100">
                    <a target="_blank" class="main-btn espace-partenaire" [href]="adminAppUrl"> <i class="fal fa-user"></i>Espace partenaire </a>
                </div>
                <!-- <span class="log-out user cust_logout" title="Déconnexion" placement="bottom" [swal]="confirmDeconnexion" *ngIf="utilisateur">
                    <img class="ml-2 colorIcon" src="assets/images/switch.png" alt="">
                </span> -->
            </nav>
        </div>
        <!-- navigation -->
    </div>
</header>
<!--====== HEADER PART ENDS ======-->


<swal #confirmDeconnexion title="Confirmation" text="Voulez-vous vraiment proceder à la déconnexion ?" icon="question" [showCancelButton]="true" [reverseButtons]="true" [focusCancel]="false" [confirmButtonText]="'Confirmer'" [cancelButtonText]="'ANNULER'"
    (confirm)="deconnexion()">
</swal>